exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-370c84a2] {\n  padding: 15px 34px;\n  display: flex;\n  justify-content: space-between;\n}\n.header h2[data-v-370c84a2] {\n  font-size: 18px;\n  font-weight: 600;\n}\n.header .status[data-v-370c84a2] {\n  font-size: 16px;\n}\n.disabled[data-v-370c84a2] {\n  background-color: #f6f8f9;\n  color: #616f7b;\n  border: 1px solid #616f7b;\n}\n.date-time[data-v-370c84a2] {\n  padding: 5px 0 5px 34px;\n}\n.date[data-v-370c84a2] {\n  color: #000;\n}", ""]);

// exports
